// PaymentForm.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";

const PaymentForm = () => {
  const [formData, setFormData] = useState({
    access_key: "63c8c15c983837f4bd3936fb19f93f51",
    profile_id: "303FF8D2-7E53-4A8A-952E-8314422CDC55",
    transaction_uuid: "",
    signed_field_names:
      "access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency",
    unsigned_field_names: "",
    signed_date_time: "",
    locale: "en-us",
    transaction_type: "authorization",
    reference_number: "",
    amount: "",
    currency: "USD",
  });

  // Generate UUID and set the current time on component mount
  useEffect(() => {
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19) + "Z";

    setFormData((prev) => ({
      ...prev,
      transaction_uuid: uuid,
      signed_date_time: utcDateTime,
    }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Update the signed date time before submission
    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19) + "Z";

    const updatedFormData = {
      ...formData,
      signed_date_time: utcDateTime,
    };

    try {
      // Send the form data to the server for signing
      const response = await axios.post("/sign_request", updatedFormData);

      // Create a form and submit it to Cybersource
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://testsecureacceptance.cybersource.com/pay";

      // Add all fields from the response
      for (const key in response.data) {
        if (response.data.hasOwnProperty(key)) {
          const hiddenField = document.createElement("input");
          hiddenField.type = "hidden";
          hiddenField.name = key;
          hiddenField.value = response.data[key];
          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error("Error signing request:", error);
    }
  };

  return (
    <div>
      <h1>Payment Form</h1>
      <form onSubmit={handleSubmit}>
        <fieldset>
          <legend>Payment Details</legend>
          <div>
            <label>Reference Number</label>
            <input
              type="text"
              name="reference_number"
              value={formData.reference_number}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label>Amount</label>
            <input
              type="text"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label>Currency</label>
            <select
              name="currency"
              value={formData.currency}
              onChange={handleChange}
            >
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
            </select>
          </div>
        </fieldset>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default PaymentForm;
